import React from 'react'
import styled from 'styled-components'

import Color from 'helpers/Color'
import Segment from 'components/UI/Segment'

// Dimmer's z-order must be smaller than ModalSegment's
const Dimmer = styled.div`
  z-index: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
`
const Wrapper = styled.div`
  z-index: 10;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
`
const ModalSegment = styled(Segment)`
  z-index: 2;
  border: solid 3px ${Color.green};
  overflow: auto;
  max-height: 100vh;
  max-width: 100vw;
  box-shadow: 0 0 20px 0px rgba(0, 0, 0, 0.3);
  pointer-events: all;
  margin: auto;
  height: auto;
  width: ${({width}) => width || 0}px;
`

const Modal = ({ children, onBlur, width, open }) => {
  if (!open) return <div />

  return (
    <Wrapper>
      <Dimmer onClick={onBlur} />
      <ModalSegment width={width}>
        {children}
      </ModalSegment>
    </Wrapper>
  )
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/UI/Modal.jsx